import { useState } from "react"
import { techWeb } from "../../data/data"
import cybersecurity from "../../images/tech-cybersecurity.svg"
import circle from "../../images/circle.svg"

export default function TechWeb() {
  const [cards] = useState(techWeb)

  return (
    <>
      <section className="px-5 2xl:px-0 py-10 lg:py-20">
        <h2 className="text-3xl text-center mb-5 lg:text-5xl">
          Web Design <span className="block">and Development</span>
        </h2>
        <p className="text-center">
          Our company provides outstanding professional websites for{" "}
          <span className="md:block">
            individuals and businesses of all shapes and sizes. We offer a wide
          </span>
          variety of pre-made templates and Tailored-made websites.
        </p>

        <div className="tech__articles pt-10 grid grid-cols-1 gap-10 xl:max-w-6xl xl:mx-auto lg:pt-20 lg:gap-20">
          {cards.map(({ id, image, title, desc }) => (
            <article key={id}>
              <div className="md:mx-5">
                <img
                  src={image}
                  alt={title}
                  title={title}
                  className="block mx-auto"
                />
              </div>

              <div className="md:w-1/2">
                <h2 className="text-3xl mb-5 lg:text-5xl">{title}</h2>
                <p className="">{desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="md:grid grid-cols-2 gap-10 items-center xl:max-w-6xl xl:mx-auto pt-10 lg:pt-20">
          <article>
            <img
              src={cybersecurity}
              alt="Consistently Great Customer Service"
              title="Consistently Great Customer Service"
              className="block mx-auto"
            />
          </article>

          <article>
            <h2 className="text-3xl mb-5 lg:text-5xl">Cybersecurity</h2>
            <p>
              We offer advanced military-grade protection for your company's
              data. We have been protecting companies for nearly a decade, and
              we do our best for our clients` security. Our team of security
              professionals is highly skilled, up-to-date on new attacks and
              threats trends. Our main goal is to provide high-level security
              services tailored to each client's budget and needs.
            </p>

            <ul>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Antivirus solutions;
              </li>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Penetration Testing;
              </li>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Awareness Education;
              </li>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                24/7 Security Monitoring (SOC);
              </li>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Endpoint detection and response solution;
              </li>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Phishing Awareness Drill and Anti-phishing solution;
              </li>
            </ul>
          </article>
        </div>
      </section>
    </>
  )
}
